import axios from '@/plugins/axios';
import SystemConst from '@/shared/system-const';
import { TableFilters } from '@/components/common/common-table-filter.component';

export default {
    namespaced: true,

    state: {
        // 一覧画面用
        /** ページ番号 */
        page: 1,

        /** 1ページ当たりの行数 */
        itemsPerPage: SystemConst.LIST_LINES_PER_PAGE[1],

        /** ソートカラム */
        sortBy: [],

        /** ソート順 */
        sortDesc: [],

        /** フィルタ条件 */
        filters: {},

        /** 詳細画面からの遷移フラグ */
        isFromDetail: false
    },

    mutations: {
        /** セッター：state.page */
        setPage(state: any, page: number) {
            state.page = page;
        },

        /** セッター：state.itemsPerPage */
        setItemsPerPage(state: any, itemsPerPage: number) {
            state.itemsPerPage = itemsPerPage;
        },

        /** セッター：state.sortBy */
        setSortBy(state: any, sortBy: string[]) {
            state.sortBy = sortBy;
        },

        /** セッター：state.sortDesc */
        setSortDesc(state: any, sortDesc: boolean[]) {
            state.sortDesc = sortDesc;
        },

        /** セッター：state.filters */
        setFilters(state: any, filters: TableFilters) {
            state.filters = filters;
        },

        /** セッター：state.isFromDetail */
        setIsFromDetail(state: any, isFromDetail: boolean) {
            state.isFromDetail = isFromDetail;
        },

        /**
         * 組織処理状況管理ストアのクリア
         * 
         * @param state ステートオブジェクト
         */
        clearStoreState(state: any) {
            state.page = 1;
            state.itemsPerPage = SystemConst.LIST_LINES_PER_PAGE[1];
            state.sortBy = [];
            state.sortDesc = [];
            state.filters = {};
            state.isFromDetail = false;
        }
    },

    actions: {
        // 処理状況一覧フィルタ情報取得API
        async getFilterConditions() {
            // 通信結果格納変数の初期化
            let result: any;

            // URL:GET /api/processing-status-organizations/filter-conditions
            // params:なし
            await axios.get('/api/processing-status-organizations/filter-conditions')
                .then((response) => {
                    // 通信結果を設定（正常）
                    result = response;
                })
                .catch((error) => {
                    // 通信結果を設定（異常）
                    result = error.response;
                })

            // 通信結果を返却する
            return result;
        },

        // 処理状況一覧取得API
        async getProcesses({ state, commit, rootState }: any, data: any) {
            // resultの初期化
            let result: any;

            // URL:GET /api/processing-status-organizations
            // params:ページ番号
            //        １ページあたりの行数
            //        ソートカラム
            //        ソート順
            //        フィルタ条件
            await axios.get('/api/processing-status-organizations',
                {
                    params: data,
                })
                .then((response) => {
                    // 通信結果を設定
                    result = response;
                })
                .catch((error) => {
                    // 通信結果を設定（エラー）
                    result = error.response;
                });

            // 通信結果を返す
            //   processingStatusOrganizations[]
            //   totalCount
            //   HTTPステータスコード
            return result;
        },

        // 処理中の処理状況確認API
        async getRunningStatus({ state, commit, rootState }: any, data: any) {
            // resultの初期化
            let result: any;

            // URL:GET /api/processing-status-organizations/{processId}/check
            // params:中間処理ID
            await axios.get(`/api/processing-status-organizations/${data.processId}/check`)
                .then((response) => {
                    // 通信結果を設定
                    result = response;
                })
                .catch((error) => {
                    // 通信結果を設定（エラー）
                    result = error.response;
                });
            // 通信結果を返す
            //   count（指定の中間処理IDが実行中である件数）
            //   HTTPステータスコード
            return result;
        },

        // 処理状況削除API
        async deleteProcess({ state, commit, rootState }: any, data: any) {
            // resultの初期化
            let result: any;

            // URL:DELETE /api/processing-status-organizations/{processId}
            // params:中間処理ID
            await axios.delete(`/api/processing-status-organizations/${data.processId}`)
                .then((response) => {
                    // 通信結果を設定
                    result = response;
                })
                .catch((error) => {
                    // 通信結果を設定（エラー）
                    result = error.response;
                });

            // 通信結果を返す
            //   HTTPステータスコード
            return result;
        },

        // 処理状況詳細一覧取得API
        async getDetail({ state, commit, rootState }: any, data: any) {
            data

            // resultの初期化
            let result: any;

            // URL:GET /api/processing-status-organizations/{processId}
            // params:中間処理ID
            await axios.get(`/api/processing-status-organizations/${data.processId}`)
                .then((response) => {
                    // 通信結果を設定
                    result = response;
                })
                .catch((error) => {
                    // 通信結果を設定（エラー）
                    result = error.response;
                });

            // 通信結果を返す
            //   processingStatusOrganizations[]
            //   HTTPステータスコード

            // 通信結果を返す
            return result;
        },

    },
}
